<template>
  <div class="page-con">
    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style"
          highlight-hover-row
          show-footer
          stripe
          ref="xGrid1"
          align="center"
          border="none"
          max-height="600"
          :data="tableData"
          :loading="loading"
          resizable
      >
        <vxe-table-column field="id" title="序号" width="60"></vxe-table-column>
        <vxe-table-column title="操作" width="50">
          <template slot-scope="{ row }">
            <Dropdown trigger="click" style="cursor: pointer" transfer v-if="isHavePermission('agreement2.0:update') && (detailData.ordersState !== 3 && detailData.ordersState !== 4)">
              <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
              <DropdownMenu slot="list">
                <div style="display: flex; flex-direction: column">
                  <Button class="button-gengduo"
                          @click="openEditView(row.id)">编辑
                  </Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="logisticsNum" title="物流编号" width="140">
          <template slot-scope="{ row }">
            <span @click="showLogisticsDetail(row.id)"
                  style="color: #2D8CF0;cursor:pointer">{{ row.logisticsNum }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="logisticsState" title="状态" width="120" show-overflow>
          <template slot-scope="{ row }">
            <span :style="isHavePermission('logistics2.0:logisticsState')? 'margin-left: 25px;':''">{{
                row.logisticsState | logisticsIsTopStatusMap
              }}</span>
            <Dropdown
                v-if="isHavePermission('logistics2.0:logisticsState')"
                trigger="click" style="margin-left: 10px;;cursor:pointer" transfer>
              <span style="position:relative; margin-left:20px; ">
                <Icon type="ios-arrow-down" style="margin-top:-3px;"/>
              </span>
              <DropdownMenu slot="list" style="left:70px;">
                <div style="display: flex;flex-direction: column;">
                  <!-- 物流状态 :  1->正常对应目前已审核 有轨迹且匹配（）、0->未知（对应目前待审核）、-1->数据异常（轨迹不匹配）、-2->离线（无轨迹） -->
                  <!-- -3 ->通信异常（平台无轨迹其他家有）、-4->AIS异常（有定位无轨迹）此状态只有船舶有 -->
                  <section v-for="item in logisticsIsTopOptions" v-bind:key="item.value">
                    <Button class="button-gengduo" v-if="row.logisticsState != item.value "
                            @click="setTop(row.id, item.value)">{{ item.label }}
                    </Button>
                  </section>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="105" show-overflow></vxe-table-column>
        <vxe-table-column field="goodsUnit" title="单位" width="60" show-overflow></vxe-table-column>
        <vxe-table-column field="realCount" title="实际数量" width="90" show-overflow></vxe-table-column>
        <vxe-table-column field="carShipNum" title="车船号" width="120" show-overflow >
          <template slot-scope="{ row }">
            <div style="display: flex;align-items: center;justify-content:center;" v-if="isHavePermission('logistics2.0:carShipDetail')">
              <span v-if="row.logisticsType === 1"
                    :style="row.carShipState === 3 ? 'color: #2D8CF0;cursor:pointer': 'cursor:pointer'"
                    @click="showCarDetail(row)">{{ row.carShipNum }}</span>
              <span v-if="row.logisticsType === 2"
                    :style="row.carShipState === 3 ? 'color: #2D8CF0;cursor:pointer': 'cursor:pointer'"
                    @click="showShipDetail(row)">{{ row.carShipNum }}</span>
            </div>
            <div style="display: flex;align-items: center;justify-content:center;" v-else>
              <span>{{ row.carShipNum }}</span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column v-if="isHavePermission('logistics2.0:getMap')" title="轨迹" width="50" show-overflow>
          <template slot-scope="{ row }">
            <div style="display: flex;align-items: center;justify-content:center;">
              <img v-if="row.trackUrl || row.logisticsType === 2"
                   style="width: 20px;height: 20px;" src="@/assets/images/common/icon-guiji.png"
                   @click="getMap(row)"/>
              <img v-else style="width: 20px;height: 20px;" src="@/assets/images/common/icon-noguiji.png"/>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="beginPlace" title="起运地" width="140" show-overflow></vxe-table-column>
        <vxe-table-column field="endPlace" title="目的地" width="140" show-overflow></vxe-table-column>
        <vxe-table-column field="beginTime" title="起运时间" width="120">
          <template slot-scope="{ row }">
            <span style="color: #a7adad">{{ row.beginTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endTime" title="到达时间" width="120">
          <template slot-scope="{ row }">
            <span style="color: #a7adad">{{ row.endTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="compName" title="平台企业" width="180" show-overflow></vxe-table-column>
        <vxe-table-column field="buyerName" title="托运人" width="180" show-overflow></vxe-table-column>
        <vxe-table-column field="sellerName" title="承运人" width="180" show-overflow></vxe-table-column>
      </vxe-table>
    </div>
    <vxe-modal v-model="detailVisible" :title="detailTitle" width="1300" height="940" @close="closeDetail"
               resize position="center">
      <detail ref="detailModal" @afterSave="afterSave" @update="goUpdate"></detail>
    </vxe-modal>
    <vxe-modal v-model="createCarVisible" :title="createCarTitle" width="1400" height="860" @close="closeCarCreate"
               resize position="center">
      <create-car-modal @afterSave="closeCarCreateModal" ref="modalCarCreate"
                        @close="closeCar"></create-car-modal>
    </vxe-modal>
    <vxe-modal v-model="createShipVisible" :title="createShipTitle" width="1400" height="900" @close="closeShipCreate"
               resize position="center" destroy-on-close>
      <create-ship-modal @afterSave="closeShipCreateModal" @close="createShipVisible = false"
                         ref="modalShipCreate"></create-ship-modal>
    </vxe-modal>
  </div>
</template>
<script>
import CreateCarModal from "@/views/carShip/CreateCarModal";
import CreateShipModal from "@/views/carShip/CreateShipModal";
import getAuthOrization from "@/mixin/getAuthOrization";
import Detail from "@/components/order2.0/Logistics/DetailModal";
import moment from "moment";
import $api from "@/apiProvider";
import $C from "@/consts";

export default {
  props: ['id', 'curTab','detailData'],
  components: {CreateCarModal, CreateShipModal, Detail},
  mixins: [getAuthOrization],
  data() {
    return {
      detailVisible: false,
      detailTitle: '',
      createCarVisible: false,
      createShipVisible: false,
      createCarTitle: '',
      createShipTitle: '',
      tableData: [{}],
      loading: false,
      logisticsIsTopOptions: $C.LogisticsIsTopStatus.options,
    }
  },
  watch: {
    curTab: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val === 2) {
          this.detail();
        }
      }
    }
  },
  methods: {
    async setTop(id, logisticsState) {
      let res = await $api.logisticsTwo.post('logistics/updateLogisticsState', {
        id: id,
        logisticsState: logisticsState
      });
      if (res.status === 1) {
        this.$Message.success('操作成功');
        this.detail();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    openEditView(id) {
      this.detailTitle = '编辑物流';
      this.detailVisible = true;
      this.$refs.detailModal.showUpdate(id);
    },
    goUpdate() {
      this.detailTitle = '编辑物流'
    },
    async detail() {
      this.loading = true;
      let res = await $api.logisticsTwo.post('logistics/detail', {
        id: this.id,
      });
      this.loading = false;
      if (res.status === 1) {
        this.tableData = [];
        this.tableData.push(res.data);
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    showLogisticsDetail(id) {
      if (!this.isHavePermission('logistics2.0:showDetail')) {
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！"
        });
        return;
      }
      this.detailTitle = '物流详情';
      this.detailVisible = true;
      this.$refs.detailModal.showDetail(id);
    },
    closeDetail() {
      this.detailVisible = false;
      this.$refs.detailModal.closeDetail();
    },
    afterSave() {
      this.detailVisible = false;
      this.detail();
    },
    showCarDetail(row) {
      if (row.carShipId) {
        this.createCarTitle = '查看车辆信息'
        this.createCarVisible = true;
        this.$refs.modalCarCreate.init();
        this.$refs.modalCarCreate.queryCarDetail(row.carShipId);
        this.$refs.modalCarCreate.setReadOnly();
      } else {
        this.$XModal.alert({
          message: '暂无车辆信息',
          status: "error",
        });
      }
    },
    showShipDetail(row) {
      if (row.carShipId) {
        this.createShipTitle = '查看船舶信息'
        this.createShipVisible = true;
        this.$nextTick(() => {
          this.$refs.modalShipCreate.queryShipDetailNew(row.carShipId);
          this.$refs.modalShipCreate.setReadOnly();
        })
      } else {
        this.$XModal.alert({
          message: '暂无船舶信息',
          status: "error",
        });
      }
    },
    closeCarCreateModal(type) {
      this.createCarVisible = false;
      // if (type === 'afterSave') {
      //   this.queryLogisticsList();
      // }
    },
    closeCarCreate() {
      this.$refs.modalCarCreate.reset();
    },
    closeCar() {
      this.createCarVisible = false;
      this.$refs.modalCarCreate.clearV();
    },
    closeShipCreateModal() {
      this.createShipVisible = false;
      // this.queryLogisticsList();
    },
    closeShipCreate() {
      this.$refs.modalShipCreate.reset();
    },
    getMap(row) {
      if (row.logisticsType === 1) {
        this.seeCarMap(row)
      } else {
        this.seeShipMap(row);
      }
    },
    seeCarMap(row) {
      let that = this;
      let url = '/carShip/fwCarFrame';
      this.fwCar = window.open(url);
      setTimeout(function () {
        that.fwCar.postMessage(JSON.stringify({carInfo: row, logistics: true}), '*');
      }, 2000);
    },
    seeShipMap(row) {
      let mmsi = row.mmsi;
      let carShipNum = row.carShipNum;
      if ((mmsi == null || mmsi === '') && (carShipNum === null || carShipNum === '')) {
        //暂无数据
        this.$Message.error('暂无数据');
        return
      }
      let beginTime = moment(row.beginTime).format("YYYY-MM-DD");
      let deliveryDates = moment(row.endTime).format("YYYY-MM-DD")
      let obj = {
        startTime: beginTime + " 00:00:00",
        endTime: deliveryDates + " 00:00:00",
        mmsi: mmsi,
        carShipNum: carShipNum,
      }
      let that = this;
      let url = '/carShip/fwShipFrame';
      this.fwShip = window.open(url);
      this.$nextTick(function () {
        setTimeout(function () {
          that.fwShip.postMessage(JSON.stringify(obj), '*')
        }, 2000);
      });
    },
    // 船舶日期往前推N天
    dateAddDays(dataStr, dayCount) {
      let isdate = new Date(dataStr.replace(/-/g, "/"));
      isdate = new Date((isdate / 1000 - (86400 * dayCount)) * 1000);//日期-N天
      let strMonth = isdate.getMonth() + 1;
      let strDate = isdate.getDate();
      let strYear = isdate.getFullYear();
      if (strMonth >= 1 && strMonth <= 9) {
        strMonth = "0" + strMonth;
      }
      if (strDate >= 1 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      return strYear + "-" + strMonth + "-" + strDate;
    },
  }
}
</script>
<style>

</style>
